import * as Period from 'constants/Period';

const BOXING_PERIOD_MAP = {};
BOXING_PERIOD_MAP[500] = Period.NOT_STARTED;
BOXING_PERIOD_MAP[501] = Period.ROUND_FIRST;
BOXING_PERIOD_MAP[502] = Period.ROUND_SECOND;
BOXING_PERIOD_MAP[503] = Period.ROUND_THIRD;
BOXING_PERIOD_MAP[504] = Period.ROUND_FOURTH;
BOXING_PERIOD_MAP[505] = Period.ROUND_FIFTH;
BOXING_PERIOD_MAP[506] = Period.ROUND_SIXTH;
BOXING_PERIOD_MAP[507] = Period.ROUND_SEVENTH;
BOXING_PERIOD_MAP[508] = Period.ROUND_EIGHTH;
BOXING_PERIOD_MAP[509] = Period.ROUND_NINTH;
BOXING_PERIOD_MAP[510] = Period.ROUND_TENTH;
BOXING_PERIOD_MAP[511] = Period.ROUND_ELEVENTH;
BOXING_PERIOD_MAP[512] = Period.ROUND_TWELFTH;
BOXING_PERIOD_MAP[513] = Period.FINISHED;

export default BOXING_PERIOD_MAP;


// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/Boxing/PeriodMap.js